import { Component, OnInit, Input,Output, EventEmitter, ViewChild } from '@angular/core';
import { InvoiceService } from '../../../services/invoice.service';
import { DatePipe } from '@angular/common';
import { encode_base64, encode_utf8 } from '../../../../environments/environment';
import Swal from 'sweetalert2';  
declare var $: any;

@Component({
  selector: 'ngx-finance-petlvl',
  templateUrl: './finance-petlvl.component.html' 
})
export class FinancePetlvlComponent implements OnInit {
  private _pet_no: number;
  private _client_no: number;
  start_date:string
  end_date:string
  clinic_no = this.invoiceService.userData.clinic_no

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  methods:any = [{method_no:1,method_code:'CASH'},{method_no:2,method_code:'CHECK'},{method_no:3,method_code:'CHARGE'},
  {method_no:4,method_code:'ATM'},{method_no:6,method_code:'COUPON'},
  {method_no:7,method_code:'ACCOUNT'},{method_no:8,method_code:'INSURANCE'},
  {method_no:5,method_code:'OTHER'}] 

  methodMap: { [key: number]: string } = {};

  constructor(
    public invoiceService: InvoiceService,
    private datePipe: DatePipe,
  ) { 
    this.methods.forEach(method => {
      this.methodMap[method.method_no] = method.method_code;
    });
  }

  ngOnInit(): void { 
    let scurrentDate =  this.datePipe.transform(new Date(), 'yyyy-MM-dd')
    this.start_date = scurrentDate
    this.end_date = scurrentDate
    this.invoiceService.GetPetInvReport(this.pet_no,this.start_date,this.end_date)

    console.log(this.invoiceService.clinic)
  }

  getMethodDesc(code: number): string {
    return this.methodMap[code] || '';
  }

  dateOnChange(){
    this.invoiceService.GetPetInvReport(this.pet_no,this.start_date,this.end_date)
  }

  printinvoice(inv_no) { 
    let $string = `admin` + "U*63r" + 'FPC_RptInvReceipt' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Invoice Receipt #${inv_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);
 
    let $strfilter = `&invoice_no=${inv_no}&pet_no=${this.pet_no}&clinic_no=${this.clinic_no}&client_no=${this.client_no}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');
  }

  print() { 
    let $string = `admin` + "U*63r" + 'FPC_PetInvoiceRpt' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Pet Invoice #${this.pet_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);
 
    let $strfilter = `&pet_no=${this.pet_no}&start_date=${this.start_date}&end_date=${this.end_date}&client_no=${this.client_no}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');
  }


}
